import {
  Badge,
  Box,
  Button,
  Drawer,
  IconButton,
  Skeleton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import NotificationItem from "components/notification/notification-item";
import { useEffect, useState } from "react";
import {
  fetchNotifications,
  markAllAsReadNotifications,
} from "slices/notificationReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";

const NotificationOpt = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const { notificationReducer }: any = useAppSelector((state) => state);
  const { appNotifications, list, listMeta, page, loadingNotifications } =
    notificationReducer;
    const theme = useTheme();
    const isMobileView = useMediaQuery(theme.breakpoints.down("md"));
  useEffect(() => {
    if (open) {
      dispatch(fetchNotifications({ page: 1 }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  return (
    <Box>
      <IconButton size="small">
        <Badge
          badgeContent={appNotifications > 100 ? `99+` : appNotifications}
          color="error"
        >
          <img
            src="/assets/img/icons/notification.svg"
            alt=""
            onClick={() => setOpen(true)}
          />
        </Badge>
      </IconButton>

      <Drawer
        anchor={"right"}
        open={open}
        onClose={() => setOpen(false)}
        sx={{ width: isMobileView ? "100%":600 }}
      >
        <Box sx={{ width:isMobileView ? "100%":600 }}>
          <Box
            sx={{
              borderBottom: "1px solid #E2E2E2",
              px: "4%",
              py: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box sx={{ display: "flex", gap: "20px", alignItems: "center" }}>
              <img
                src="/assets/img/icons/arrow_left.svg"
                height="24"
                width="24"
                onClick={() => setOpen(false)}
                role="button"
                alt=""
              />
              <Typography
                sx={{
                  fontSize: "22px",
                  fontWeight: 600,
                  lineHeight: "31px",
                }}
              >
                Notifications
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "#307AFF",
                fontWeight: 500,
                fontSize: "15px",
                lineHeight: "18px",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => dispatch(markAllAsReadNotifications())}
            >
              Mark all as read
            </Typography>
          </Box>
          <Box height="100%" overflow="auto">
            {list.length > 0 &&
              list.map((item: any, iDx: number) => (
                <NotificationItem
                  key={iDx}
                  {...item}
                  onClose={() => setOpen(false)}
                />
              ))}
            {listMeta?.totalPages > 1 &&
              !loadingNotifications &&
              page !== listMeta?.totalPages && (
                <Box display="flex" justifyContent="center" my={6}>
                  <Button
                    onClick={() =>
                      dispatch(fetchNotifications({ page: page + 1 }))
                    }
                  >
                    Load More Notifications
                  </Button>
                </Box>
              )}
            {loadingNotifications && (
              <Stack gap={1} px="20px">
                {[1, 2, 3, 4].map(() => (
                  <Skeleton variant="rectangular" height={100} />
                ))}
              </Stack>
            )}
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default NotificationOpt;
